import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import Hidden from '@material-ui/core/Hidden';
import ItemCardSkeleton from '../../../../../components/ItemCard/ItemCardSkeleton';
import ParcelSkeleton from '../../../../../components/Parcel/ParcelSkeleton';
import PickItemQuantityCounterSkeleton from '../PickItemQuantityCounterSkeleton';
import PickItemPropertySkeleton from '../PickItemPropertySkeleton';
import translations from '../translations';

const PickItemSkeleton = ({ showCrate, showPacking }) => {
  const intl = useIntl();

  return (
    <>
      {showPacking && (
        <Hidden smDown implementation="js">
          <ParcelSkeleton />
          <Box py={2}>
            <Divider />
          </Box>
        </Hidden>
      )}
      <ItemCardSkeleton />
      <Box flex={1} p={2}>
        <PickItemPropertySkeleton label={intl.formatMessage(translations.properties.position)} />

        {showCrate && (
          <Box my={2}>
            <PickItemPropertySkeleton label={intl.formatMessage(translations.properties.crate)} />
          </Box>
        )}
      </Box>
      <PickItemQuantityCounterSkeleton />
      {showPacking && (
        <Hidden mdUp implementation="js">
          <Box py={1}>
            <ParcelSkeleton />
          </Box>
        </Hidden>
      )}
    </>
  );
};

PickItemSkeleton.propTypes = {
  showCrate: PropTypes.bool,
  showPacking: PropTypes.bool,
};

PickItemSkeleton.defaultProps = {
  showCrate: false,
  showPacking: false,
};

export default PickItemSkeleton;
